"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ElementalShieldAbilityHandler = exports.ElementalShieldActorAbilityFactory = exports.ElementalShieldAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const MaxAttributeIncrease_1 = require("../../core/effects/core/MaxAttributeIncrease");
const AttributeType_1 = require("../../core/enums/AttributeType");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const core_2 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
const Settings_1 = require("../../Settings");
class ElementalShieldAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.ElementalShield;
        this.__typeName = "ElementalShield";
    }
}
exports.ElementalShieldAbilityArgs = ElementalShieldAbilityArgs;
let ElementalShieldActorAbilityFactory = class ElementalShieldActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("ElementalShield", "AllAllies", 4);
    }
};
ElementalShieldActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("ElementalShield")
], ElementalShieldActorAbilityFactory);
exports.ElementalShieldActorAbilityFactory = ElementalShieldActorAbilityFactory;
let ElementalShieldAbilityHandler = class ElementalShieldAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const livingAllies = container.selectLivingTargets(ability.invokerId, Target_1.Target.AllAllies);
        container.applyAbilityAnimation({
            sequence,
            animatedId: ability.invokerId,
            abilityKey: ability.args.__typeName,
            fallback: "casting",
            onAnimated(sequence) {
                for (const targetId of livingAllies) {
                    container.applyBuff({
                        sequence: sequence.pushSequence("sequential"),
                        creatorId: ability.invokerId,
                        targetId,
                        duration: Duration_1.Duration.Turns(4),
                        effect: new core_1.LinkedEffectsEffectArgs([
                            new MaxAttributeIncrease_1.MaxAttributeIncreaseEffectArgs(AttributeType_1.AttributeType.Will, container.getPercentOfBaseAttributeScore(targetId, 10, "Will")),
                            new MaxAttributeIncrease_1.MaxAttributeIncreaseEffectArgs(AttributeType_1.AttributeType.AllDamageResistance, Settings_1.BASE_LEVEL_ADR * container.getLevel(ability.invokerId))
                        ], false),
                        onApplied(sequence) {
                            sequence.push(new core_2.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(targetId, "chest"), "FourElementSwirl"));
                        }
                    });
                }
            }
        });
    }
};
ElementalShieldAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.ElementalShield)
], ElementalShieldAbilityHandler);
exports.ElementalShieldAbilityHandler = ElementalShieldAbilityHandler;
